import type { Product } from "constants/modelCompareData/types";
import type { StoreId } from "@ubnt/store.core/lib/types";
import type { AdditionProductData } from "../CompareTable.types";
import { transformProductForCompare } from "./transformProductForCompare";

export const createEmptyGridItems = ({
  emptyItem,
  numberOfEmptyColumns,
  storeId,
  additionalProductData,
  isMobile,
}: {
  emptyItem: Product;
  numberOfEmptyColumns: number;
  storeId: StoreId;
  additionalProductData?: AdditionProductData;
  isMobile: boolean;
}) => {
  const emptyGridItems = Array.from(
    {
      length: isMobile ? 0 : numberOfEmptyColumns,
    },
    () =>
      transformProductForCompare({
        product: emptyItem,
        storeId,
        additionalProductData,
      }),
  );

  return emptyGridItems;
};
